/* Nacional Prime — tema Shopify. Comportamento da loja (menu, sacola, kits, personalizadores). */
(function () {
  'use strict';

  var NP = window.NP || {};
  var ICONS = {"check": "<path d=\"M20 6 9 17l-5-5\"></path>", "badge-check": "<path d=\"M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z\"></path><path d=\"m9 12 2 2 4-4\"></path>", "search": "<path d=\"m21 21-4.34-4.34\"></path><circle cx=\"11\" cy=\"11\" r=\"8\"></circle>", "chevron-down": "<path d=\"m6 9 6 6 6-6\"></path>", "car-front": "<path d=\"m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8\"></path><path d=\"M7 14h.01\"></path><path d=\"M17 14h.01\"></path><rect width=\"18\" height=\"8\" x=\"3\" y=\"10\" rx=\"2\"></rect><path d=\"M5 18v2\"></path><path d=\"M19 18v2\"></path>", "camera": "<path d=\"M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z\"></path><circle cx=\"12\" cy=\"13\" r=\"3\"></circle>", "loader-circle": "<path d=\"M21 12a9 9 0 1 1-6.219-8.56\"></path>", "x": "<path d=\"M18 6 6 18\"></path><path d=\"m6 6 12 12\"></path>"};

  function icon(name, cls, stroke) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (stroke == null ? 2 : stroke) + '" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-' + name + ' ' + (cls || '') + '" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Dinheiro ---------------- */
  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    var parts = value.toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = intPart + ',' + parts[1];
    var fmt = NP.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_m, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals_with_comma_separator') return intPart;
      if (key === 'amount') return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d)\.)/g, ',');
      return withComma;
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------------- Toast (mesmo visual do sonner) ---------------- */
  var TOAST_ICONS = {
    error: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>',
    success: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>'
  };
  function toast(message, type) {
    type = type || 'error';
    var list = $('[data-np-toaster]');
    if (!list) { window.alert(message); return; }
    list.hidden = false;
    $$('li[data-sonner-toast]', list).forEach(function (old) { old.remove(); });
    var li = document.createElement('li');
    li.tabIndex = 0;
    li.className = 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg';
    var attrs = { 'data-sonner-toast': '', 'data-styled': 'true', 'data-mounted': 'false', 'data-promise': 'false', 'data-swiped': 'false', 'data-removed': 'false', 'data-visible': 'true', 'data-y-position': 'top', 'data-x-position': 'center', 'data-index': '0', 'data-front': 'true', 'data-swiping': 'false', 'data-dismissible': 'true', 'data-type': type, 'data-swipe-out': 'false', 'data-expanded': 'false' };
    Object.keys(attrs).forEach(function (k) { li.setAttribute(k, attrs[k]); });
    li.setAttribute('style', '--index: 0; --toasts-before: 0; --z-index: 1; --offset: 0px; --initial-height: 53.5px;');
    li.innerHTML = '<div data-icon="" class="">' + (TOAST_ICONS[type] || '') + '</div><div data-content="" class=""><div data-title="" class="">' + esc(message) + '</div></div>';
    list.appendChild(li);
    requestAnimationFrame(function () {
      li.style.setProperty('--initial-height', li.offsetHeight + 'px');
      list.style.setProperty('--front-toast-height', li.offsetHeight + 'px');
      li.setAttribute('data-mounted', 'true');
    });
    setTimeout(function () {
      li.setAttribute('data-removed', 'true');
      li.setAttribute('data-mounted', 'false');
      setTimeout(function () { li.remove(); if (!list.children.length) list.hidden = true; }, 400);
    }, 4000);
  }
  NP.toast = toast;

  /* ---------------- Sheets (menu e sacola) ---------------- */
  var openSheet = null;
  function showSheet(name) {
    var root = $('[data-sheet="' + name + '"]');
    if (!root) return;
    if (openSheet && openSheet !== root) hideSheet(openSheet, true);
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var parts = $$('[data-sheet-overlay],[data-sheet-content]', root);
    parts.forEach(function (el) { el.setAttribute('data-state', 'closed'); });
    void root.offsetWidth;
    parts.forEach(function (el) { el.setAttribute('data-state', 'open'); el.style.pointerEvents = 'auto'; });
    $$('[data-sheet-close].absolute', root).forEach(function (b) { b.setAttribute('data-state', 'open'); });
    openSheet = root;
    var content = $('[data-sheet-content]', root);
    if (content) setTimeout(function () { content.focus({ preventScroll: true }); }, 50);
    if (name === 'cart-sheet') renderCart();
  }
  function hideSheet(root, immediate) {
    if (!root || root.hidden) return;
    $$('[data-sheet-overlay],[data-sheet-content]', root).forEach(function (el) { el.setAttribute('data-state', 'closed'); });
    var done = function () { root.hidden = true; };
    if (immediate) done(); else setTimeout(done, 290);
    document.documentElement.style.overflow = '';
    if (openSheet === root) openSheet = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sheet-open]');
    if (opener) { e.preventDefault(); showSheet(opener.getAttribute('data-sheet-open')); return; }
    var closer = e.target.closest('[data-sheet-close],[data-sheet-overlay]');
    if (closer) {
      var root = closer.closest('[data-sheet]');
      if (root) {
        var href = closer.getAttribute('href');
        hideSheet(root);
        if (href && href.charAt(0) === '/' && href.indexOf('#') > -1 && location.pathname === href.split('#')[0]) {
          // âncora na mesma página: deixa o navegador rolar
        }
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSheet) hideSheet(openSheet); });

  /* ---------------- Acordeões ---------------- */
  function setAccordion(item, open) {
    var trigger = $('[data-accordion-trigger]', item);
    var content = $('[data-accordion-content]', item);
    if (!content) return;
    if (open) {
      content.hidden = false;
      var h = content.scrollHeight;
      content.style.setProperty('--radix-accordion-content-height', h + 'px');
      [item, trigger, content].forEach(function (el) { el && el.setAttribute('data-state', 'open'); });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    } else {
      content.style.setProperty('--radix-accordion-content-height', content.scrollHeight + 'px');
      [item, trigger, content].forEach(function (el) { el && el.setAttribute('data-state', 'closed'); });
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var finish = function () { if (content.getAttribute('data-state') === 'closed') content.hidden = true; };
      content.addEventListener('animationend', finish, { once: true });
      setTimeout(finish, 350);
    }
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    var group = trigger.closest('[data-accordion]');
    var isOpen = item.getAttribute('data-state') === 'open';
    if (group && group.getAttribute('data-accordion') === 'single' && !isOpen) {
      $$('[data-accordion-item][data-state="open"]', group).forEach(function (other) { if (other !== item) setAccordion(other, false); });
    }
    setAccordion(item, !isOpen);
  });

  /* ---------------- Sacola ---------------- */
  var cartState = null;
  function isKitOption(name) {
    var n = String(name || '').toLowerCase();
    return n === 'kit' || n.indexOf('leve mais') > -1;
  }
  function lineUnits(item) {
    var opts = item.options_with_values || [];
    var kit = opts.filter(function (o) { return isKitOption(o.name); })[0];
    var n = parseInt(String(kit ? kit.value : ''), 10);
    return n > 0 ? n : 1;
  }
  // Opções da variante que não são o kit (ex.: "Jade", "50 Litros / Americana", "Toyota").
  function variantLabel(item) {
    if (item.product_has_only_default_variant) return '';
    return (item.options_with_values || []).filter(function (o) { return !isKitOption(o.name); })
      .map(function (o) { return o.value; }).join(' / ');
  }
  function updateCount(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) { total += lineUnits(it) > 1 ? lineUnits(it) * it.quantity : it.quantity; });
    $$('[data-cart-count]').forEach(function (el) { el.textContent = total; el.hidden = total === 0; });
  }
  function fetchCart() {
    return fetch((NP.routes && NP.routes.cartJs) || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartState = cart; updateCount(cart); return cart; });
  }
  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function renderCart(cart) {
    var root = $('[data-sheet="cart-sheet"]');
    if (!root) return;
    if (!cart) { fetchCart().then(renderCart); return; }
    var items = cart.items || [];
    $('[data-cart-empty]', root).hidden = items.length > 0;
    $('[data-cart-filled]', root).hidden = items.length === 0;
    $('[data-cart-footer]', root).hidden = items.length === 0;
    var list = $('[data-cart-items]', root);
    var tpl = $('[data-cart-item-template]', root);
    list.innerHTML = '';
    items.forEach(function (it) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var units = lineUnits(it);
      var props = it.properties || {};
      var img = $('[data-item-image]', node);
      img.src = sizedImage(it.image, 160);
      img.alt = it.product_title;
      $('[data-item-title]', node).textContent = (units > 1 ? units + 'x ' : '') + it.product_title;
      var label = [variantLabel(it), props._label || labelFromProps(props)].filter(Boolean).join(' • ') || (units > 1 ? 'Kit ' + units + ' unidades' : '');
      var vEl = $('[data-item-variant]', node);
      if (label) vEl.textContent = label; else vEl.remove();
      $('[data-item-note]', node).textContent = NP.cartShipNote || '';
      $('[data-item-qty]', node).textContent = it.quantity;
      $('[data-item-price]', node).textContent = formatMoney(it.final_line_price);
      $('[data-item-remove]', node).addEventListener('click', function () { changeLine(it.key, 0); });
      $('[data-item-minus]', node).addEventListener('click', function () { changeLine(it.key, Math.max(1, it.quantity - 1)); });
      $('[data-item-plus]', node).addEventListener('click', function () { changeLine(it.key, it.quantity + 1); });
      list.appendChild(node);
    });
    $('[data-cart-subtotal]', root).textContent = formatMoney(cart.total_price);
  }
  function changeLine(key, quantity) {
    return fetch((NP.routes && NP.routes.cartChange) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      cartState = cart; updateCount(cart); renderCart(cart);
    }).catch(function () { toast('Não foi possível atualizar o carrinho.'); });
  }
  function addToCart(formData) {
    return fetch((NP.routes && NP.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Não foi possível adicionar ao carrinho.');
        return json;
      });
    });
  }
  NP.addToCart = addToCart;
  /* ---------------- Preparar o carrinho para o pagamento ---------------- */
  /*
   * O checkout (Zedy) junta linhas da mesma variante e fica só com a personalização da primeira
   * (ex.: GelaCar S10 + GelaCar RAM viravam "2x" com a placa da RAM). Antes de ir para o pagamento,
   * juntamos nós mesmos as linhas iguais numa só, com a personalização de cada item numerada
   * ("Item 1 - ...", "Item 2 - ..."). Também tiramos o _label, que só serve para a sacola e aparecia
   * duplicado no checkout.
   */
  var ITEM_PREFIX = /^Item (\d+)(?: \((\d+)x\))? - (.+)$/;
  function visibleProps(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && props[k] != null && props[k] !== '') out[k] = String(props[k]);
    });
    return out;
  }
  function labelFromProps(props) {
    var vis = visibleProps(props);
    return Object.keys(vis).map(function (k) { return k + ': ' + (/^https?:\/\//.test(vis[k]) ? 'foto enviada' : vis[k]); }).join(' | ');
  }
  // Itens de uma linha: uma linha já juntada ("Item N - ...") volta a ser separada nos itens originais.
  function lineSubItems(line) {
    var props = visibleProps(line.properties), groups = {}, order = [];
    Object.keys(props).forEach(function (k) {
      var m = ITEM_PREFIX.exec(k);
      if (!m) return;
      if (!groups[m[1]]) { groups[m[1]] = { qty: Number(m[2] || 1), props: {} }; order.push(m[1]); }
      groups[m[1]].props[m[3]] = props[k];
    });
    if (!order.length) return [{ qty: line.quantity, props: props }];
    var subs = order.map(function (n) { return groups[n]; });
    var sum = subs.reduce(function (a, x) { return a + x.qty; }, 0);
    if (line.quantity > sum) subs[subs.length - 1].qty += line.quantity - sum;
    return subs;
  }
  function mergeLines(lines) {
    var subs = [];
    lines.forEach(function (l) { subs = subs.concat(lineSubItems(l)); });
    var props = {}, qty = 0;
    subs.forEach(function (x, i) {
      qty += x.qty;
      var head = 'Item ' + (i + 1) + (x.qty > 1 ? ' (' + x.qty + 'x)' : '');
      Object.keys(x.props).forEach(function (k) { props[head + ' - ' + k] = x.props[k]; });
    });
    return { id: lines[0].variant_id, quantity: qty, properties: props };
  }
  function postJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function prepareCartForCheckout() {
    return fetchCart().then(function (cart) {
      var byVariant = {}, order = [];
      (cart.items || []).slice().reverse().forEach(function (it) { // mais antigos primeiro
        if (!byVariant[it.variant_id]) { byVariant[it.variant_id] = []; order.push(it.variant_id); }
        byVariant[it.variant_id].push(it);
      });
      var remove = {}, add = [];
      order.forEach(function (vid) {
        var lines = byVariant[vid];
        if (lines.length > 1) {
          lines.forEach(function (l) { remove[l.key] = 0; });
          add.push(mergeLines(lines));
        } else if (lines[0].properties && Object.prototype.hasOwnProperty.call(lines[0].properties, '_label')) {
          remove[lines[0].key] = 0;
          add.push({ id: lines[0].variant_id, quantity: lines[0].quantity, properties: visibleProps(lines[0].properties) });
        }
      });
      if (!add.length) return cart;
      var cartBase = ((NP.routes && NP.routes.cart) || '/cart').replace(/\/$/, '');
      return postJson(cartBase + '/update.js', { updates: remove })
        .then(function () { return postJson((NP.routes && NP.routes.cartAdd) || '/cart/add.js', { items: add }); })
        .then(fetchCart);
    });
  }
  /*
   * Ida rápida para o pagamento: em vez de abrir a página /cart só para o script da Zedy rodar, pedimos o
   * checkout à Zedy daqui mesmo (mesma chamada que o script dela faz), esvaziamos o carrinho em paralelo
   * e seguimos direto. Se algo falhar, volta ao caminho antigo pela página /cart.
   */
  var ZEDY_API = 'https://app.zedy.com.br/api/public/shopify';
  var CHECKOUT_PENDING_KEY = 'np-checkout-pending';
  function showCheckoutLoader() {
    var el = document.getElementById('np-checkout-loader');
    if (!el) {
      el = document.createElement('div');
      el.id = 'np-checkout-loader';
      el.setAttribute('role', 'status');
      el.innerHTML = '<div class="np-checkout-loader__box"><span class="np-checkout-loader__spin" aria-hidden="true"></span><p>Abrindo o pagamento seguro…</p></div>';
      document.body.appendChild(el);
    }
    el.hidden = false;
  }
  function hideCheckoutLoader() {
    var el = document.getElementById('np-checkout-loader');
    if (el) el.hidden = true;
    $$('[data-checkout]').forEach(function (a) { a.removeAttribute('aria-busy'); a.style.opacity = ''; });
  }
  function withTracking(url) {
    try { return typeof window.cht_getUrlWithUtms === 'function' ? window.cht_getUrlWithUtms(url) : url; } catch (e) { return url; }
  }
  function openZedyCheckout(cart) {
    if (!cart || !cart.item_count) return Promise.reject(new Error('vazio'));
    return fetch(ZEDY_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ shop: (window.Shopify && window.Shopify.shop) || '', origin: location.host, cart_payload: cart })
    }).then(function (r) { if (!r.ok) throw new Error('zedy'); return r.json(); }).then(function (resp) {
      if (!resp || !resp.active || !resp.checkout_direct_url) throw new Error('zedy');
      saveCartBackup(cart);
      try { localStorage.setItem(CHECKOUT_PENDING_KEY, String(Date.now())); } catch (e) {}
      if (resp.skip_cart) {
        fetch('/cart/clear.js?revy-request=t', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}', keepalive: true }).catch(function () {});
      }
      window.location.href = withTracking(resp.checkout_direct_url);
    });
  }
  function goToCheckout() {
    showCheckoutLoader();
    var fallback = function () { window.location.href = (NP.routes && NP.routes.checkout) || '/cart'; };
    prepareCartForCheckout().then(openZedyCheckout).catch(fallback);
  }
  NP.goToCheckout = goToCheckout;
  // "Finalizar pedido" da sacola
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-checkout]');
    if (!link) return;
    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    link.style.opacity = '0.7';
    goToCheckout();
  });

  NP.openCart = function () { fetchCart().then(function (c) { renderCart(c); showSheet('cart-sheet'); }); };

  /* ---------------- Carrinho preservado durante o pagamento ---------------- */
  /*
   * O checkout (Zedy) esvazia o carrinho da Shopify ao abrir o pagamento. Na página /cart (caminho até o
   * pagamento) guardamos uma cópia do carrinho. Se o cliente voltar do pagamento sem comprar, ele cai de
   * novo em /cart já vazio: os produtos voltam para o carrinho, ele retorna à página onde estava e a
   * sacola abre para continuar escolhendo.
   */
  var CART_BACKUP_KEY = 'np-cart-backup';
  var CART_BACKUP_MAX_AGE = 6 * 60 * 60 * 1000;
  var OPEN_CART_FLAG = 'np-open-cart';
  function isCartPage() {
    var cartPath = ((NP.routes && NP.routes.cart) || '/cart').replace(/\/$/, '');
    return location.pathname.replace(/\/$/, '') === cartPath;
  }
  function saveCartBackup(cart) {
    try {
      var items = (cart.items || []).map(function (it) {
        var props = {}, raw = it.properties || {};
        // Aceita objeto { nome: valor } ou lista de pares [nome, valor].
        var pairs = Array.isArray(raw) ? raw : Object.keys(raw).map(function (k) { return [k, raw[k]]; });
        pairs.forEach(function (p) { if (p && p[0] != null && p[1] != null && p[1] !== '') props[String(p[0])] = String(p[1]); });
        return { id: it.id || it.variant_id, quantity: it.quantity, properties: props };
      });
      if (items.length) localStorage.setItem(CART_BACKUP_KEY, JSON.stringify({ at: Date.now(), items: items }));
    } catch (e) {}
  }
  function readCartBackup() {
    try {
      var b = JSON.parse(localStorage.getItem(CART_BACKUP_KEY) || 'null');
      if (b && b.items && b.items.length && Date.now() - b.at < CART_BACKUP_MAX_AGE) return b;
      localStorage.removeItem(CART_BACKUP_KEY);
    } catch (e) {}
    return null;
  }
  function restoreCartBackup() {
    var backup = readCartBackup();
    if (!backup) return false;
    fetch((NP.routes && NP.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: backup.items })
    }).then(function (r) {
      if (!r.ok) throw new Error('restore');
      try { localStorage.removeItem(CART_BACKUP_KEY); sessionStorage.setItem(OPEN_CART_FLAG, '1'); } catch (e) {}
      var ref = document.referrer;
      var back = ref && ref.indexOf(location.origin + '/') === 0 && !/\/cart(\?|#|$)/.test(ref.replace(location.origin, '')) ? ref : '/';
      location.replace(back);
    }).catch(function () {});
    return true;
  }
  function checkoutPending() {
    try { var t = Number(localStorage.getItem(CHECKOUT_PENDING_KEY) || 0); return !!t && Date.now() - t < CART_BACKUP_MAX_AGE; } catch (e) { return false; }
  }
  function cameBackHere() {
    try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; }
  }
  // Voltou do pagamento direto para a página do produto: refaz o carrinho aqui mesmo e abre a sacola.
  function restoreHere() {
    var backup = readCartBackup();
    if (!backup) return;
    fetchCart().then(function (cart) {
      if (cart.item_count) return;
      return postJson((NP.routes && NP.routes.cartAdd) || '/cart/add.js', { items: backup.items }).then(function () {
        try { localStorage.removeItem(CART_BACKUP_KEY); localStorage.removeItem(CHECKOUT_PENDING_KEY); } catch (e) {}
        return fetchCart();
      }).then(function (c) { renderCart(c); showSheet('cart-sheet'); });
    }).catch(function () {});
  }
  function initCartBackup() {
    if (!isCartPage()) {
      if (checkoutPending() && cameBackHere()) restoreHere();
      return;
    }
    var el = $('[data-cart-json]');
    var cart = null;
    try { cart = el && JSON.parse(el.textContent); } catch (e) {}
    if (!cart) return;
    if (cart.item_count > 0) saveCartBackup(cart);
    else restoreCartBackup();
  }
  // Volta pelo botão do navegador com a página guardada em cache: confere o carrinho de verdade.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    hideCheckoutLoader();
    if (isCartPage()) fetchCart().then(function (cart) { if (!cart.item_count) restoreCartBackup(); }).catch(function () {});
    else if (checkoutPending()) restoreHere();
  });

  /* ---------------- Banner principal ---------------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var track = $('[data-hero-track]', hero);
      var dots = $$('[data-hero-dot]', hero);
      if (!track || dots.length < 2) return;
      var setActive = function (i) {
        dots.forEach(function (d, j) {
          d.classList.toggle('w-5', i === j); d.classList.toggle('bg-white', i === j);
          d.classList.toggle('w-2', i !== j); d.classList.toggle('bg-white/60', i !== j);
        });
      };
      track.addEventListener('scroll', function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }); });
      setInterval(function () {
        var next = (Math.round(track.scrollLeft / track.clientWidth) + 1) % dots.length;
        track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      }, 5000);
    });
  }

  /* ---------------- Vídeo "recado" ---------------- */
  function initVideoSections() {
    $$('[data-video-section]').forEach(function (sec) {
      var btn = $('[data-video-play]', sec);
      var video = $('video', sec);
      if (!btn || !video) return;
      btn.addEventListener('click', function () {
        if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
        btn.remove();
        video.controls = true;
        video.muted = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
      });
    });
  }

  /* ---------------- Rastreio ---------------- */
  function initTracking() {
    var form = $('[data-tracking-form]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var params = new URLSearchParams(location.search);
    if (params.get('q')) input.value = params.get('q');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      var msg = $('[data-tracking-message]');
      var acc = $('[data-tracking-account]');
      var err = $('[data-tracking-error]');
      err.hidden = true;
      var looksLikeCode = /^[A-Za-z]{2}\d{9}[A-Za-z]{2}$/.test(q.replace(/\s/g, '')) || (/[A-Za-z]/.test(q) && /\d/.test(q) && q.indexOf('@') === -1 && q.replace(/\s/g, '').length >= 8);
      if (looksLikeCode) {
        var url = (form.getAttribute('data-tracking-url') || 'https://t.17track.net/pt-br#nums={code}').replace('{code}', encodeURIComponent(q.replace(/\s/g, '').toUpperCase()));
        window.open(url, '_blank', 'noopener');
        msg.textContent = 'Abrimos o rastreio da transportadora em uma nova aba para o código ' + q.toUpperCase() + '.';
        acc.hidden = true;
      } else {
        msg.textContent = 'Para ver o status e o rastreio do seu pedido, entre com o e-mail usado na compra. Você também recebe o código de rastreio por e-mail assim que o pedido é enviado.';
        acc.hidden = false;
      }
    });
  }

  /* ================= Página de produto ================= */
  var CLS = {
    choice: 'inline-flex items-center gap-2 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border hover:bg-accent hover:text-accent-foreground h-auto min-h-11 min-w-0 justify-center whitespace-normal break-words rounded-md px-1.5 py-1.5 text-center text-[13px] font-bold leading-tight',
    choiceOn: 'border-[hsl(var(--store-blue))] bg-[hsl(var(--store-blue))]/10 text-[hsl(var(--store-blue))] ring-1 ring-[hsl(var(--store-blue))]',
    choiceOff: 'border-border bg-background text-foreground',
    link: 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 underline-offset-4 hover:underline',
    select: 'h-11 w-full appearance-none rounded-md border border-input bg-background pl-9 pr-8 text-base font-medium text-foreground outline-none focus:border-[hsl(var(--store-blue))] focus:ring-2 focus:ring-[hsl(var(--store-blue))]/15 disabled:cursor-not-allowed disabled:opacity-45',
    manualInput: 'h-11 w-full rounded-md border border-input bg-background px-3 text-base font-medium outline-none focus:border-[hsl(var(--store-blue))] focus:ring-2 focus:ring-[hsl(var(--store-blue))]/15',
    confirmPlate: 'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 px-4 py-2 mt-2 h-11 w-full rounded-md bg-[hsl(var(--store-blue))] font-bold text-primary-foreground hover:bg-[hsl(var(--store-blue-dark))]',
    ghostSm: 'inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-9 rounded-md px-3 shrink-0 text-[12px]',
    truckSelect: 'h-11 w-full rounded-md border border-input bg-background px-3 text-[16px] font-medium text-foreground outline-none transition-colors focus:border-primary focus:ring-2 focus:ring-primary/15 disabled:cursor-not-allowed disabled:bg-muted/50 disabled:text-muted-foreground',
    truckColor: 'inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border hover:bg-accent hover:text-accent-foreground px-4 py-2 h-11 min-w-0 gap-2 rounded-md text-[12px] font-medium sm:text-[13px]',
    truckColorOn: 'border-primary bg-primary/5 ring-1 ring-primary/20',
    truckColorOff: 'border-border bg-background',
    confirmVehicle: 'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 px-4 py-2 mt-4 h-12 w-full rounded-md bg-[hsl(var(--store-blue))] font-extrabold text-primary-foreground hover:bg-[hsl(var(--store-blue-dark))]',
    station: 'items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border hover:bg-accent hover:text-accent-foreground relative flex h-[78px] min-w-0 flex-col gap-1 rounded-md px-1 py-2 sm:h-[88px]',
    stationOn: 'border-[hsl(var(--store-blue))] bg-[hsl(var(--store-blue))]/5 ring-1 ring-[hsl(var(--store-blue))]',
    stationOff: 'border-border bg-background',
    removePhoto: 'inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground px-3 h-8 gap-1.5 text-[12.5px] text-muted-foreground'
  };

  function isTextField(el) {
    return !!el && (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && el.type !== 'file'));
  }

  function keepViewportStill(fn) {
    var x = window.scrollX, y = window.scrollY;
    var typing = isTextField(document.activeElement);
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    fn();
    // Com o teclado do celular aberto, a posição salva não vale mais depois que ele fecha.
    if (typing) return;
    var restore = function () { window.scrollTo({ left: x, top: y, behavior: 'instant' }); };
    restore();
    requestAnimationFrame(function () { restore(); requestAnimationFrame(restore); });
  }

  /*
   * Confirma o que o cliente digitou: fecha o teclado, aplica a mudança (update) e, quando o teclado
   * terminar de fechar, rola a tela suavemente até o resultado se ele não estiver inteiro à vista.
   * O estado do teclado é lido antes da mudança, porque ela tira o campo da tela.
   */
  function confirmAndReveal(update, getTarget) {
    var vv = window.visualViewport;
    var keyboardOpen = !!vv && isTextField(document.activeElement) && vv.height < window.innerHeight * 0.85;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    update();
    var reveal = function () {
      var el = getTarget();
      if (!el) return;
      var r = el.getBoundingClientRect();
      var viewHeight = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      var margin = 96; // mesmo respiro do scroll-mt-24
      if (r.top < margin || r.bottom > viewHeight) {
        window.scrollTo({ top: Math.max(0, window.scrollY + r.top - margin), behavior: 'smooth' });
      }
    };
    if (!keyboardOpen) { requestAnimationFrame(function () { requestAnimationFrame(reveal); }); return; }
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      vv.removeEventListener('resize', onResize);
      requestAnimationFrame(reveal);
    };
    var onResize = function () { if (vv.height >= window.innerHeight * 0.9) setTimeout(finish, 60); };
    vv.addEventListener('resize', onResize);
    setTimeout(finish, 650);
  }

  /* ---------- GelaCar ---------- */
  var GELACAR_COLORS = { Branco: '#f6f6f4', Preto: '#24282B', Prata: '#bfc4c5', Cinza: '#777e82', Azul: '#3263a0', Vermelho: '#c43e3e', Verde: '#367448', Bege: '#d5c4a7', Marrom: '#73513e' };
  function emptyGelacar() { return { view: '', category: '', brand: '', model: '', year: '', color: '', plateName: '', confirmed: false, manual: false, collapsed: false }; }
  function gelacarReady(u) { return !!(u.view && u.category && u.brand.trim() && u.model.trim() && u.year && u.color); }
  function gelacarComplete(u) {
    return !!(u.view && u.category && u.brand.trim() && u.model.trim() && /^\d{4}$/.test(u.year) && Number(u.year) <= new Date().getFullYear() && u.color && u.plateName.trim() && u.confirmed);
  }
  function gelacarValue(u, mode) {
    return u.brand + ' ' + u.model + ' ' + u.year + ' • ' + u.color + ' • ' + (u.view === 'front' ? 'Frente' : 'Traseira') + ' • ' + (mode.sizes ? 'Tamanho: ' : 'Placa: ') + u.plateName.trim();
  }

  /*
   * Modos do personalizador de carro. O GelaCar pede o nome da placa; a capa de ar-condicionado
   * (personalização "capa" no produto) pede o tamanho do aparelho no lugar do nome.
   */
  var GELACAR_MODE = { title: 'Personalize seu GelaCar', summary: 'Seu GelaCar', incomplete: 'Complete a personalização do seu GelaCar.' };
  var CAPA_MODE = {
    title: 'Personalize sua capa', summary: 'Sua capa', incomplete: 'Complete a personalização da sua capa.',
    sizes: ['9.000 BTUS', '12.000 BTUS', '18.000 BTUS', '24.000 BTUS', '30.000 BTUS', '36.000 BTUS']
  };

  /*
   * Placa com o nome do cliente. Com animate, a placa entra suave, as letras surgem uma a uma
   * (como se fossem gravadas) e um brilho passa por ela no final.
   */
  function plateHtml(name, img, animate) {
    var n = String(name || '').trim();
    var size = n.length > 28 ? 'clamp(5px,2.7cqw,10px)' : n.length > 19 ? 'clamp(6px,3.6cqw,13px)' : n.length > 12 ? 'clamp(7px,4.6cqw,17px)' : 'clamp(9px,7cqw,24px)';
    var chars = Array.from(n);
    var step = Math.min(45, 600 / Math.max(1, chars.length)), start = 150;
    var text = animate ? chars.map(function (c, i) {
      return '<span class="plate-letter" style="animation-delay:' + Math.round(start + i * step) + 'ms">' + (c === ' ' ? '&nbsp;' : esc(c)) + '</span>';
    }).join('') : esc(n);
    return '<div class="' + (animate ? 'plate-in ' : '') + 'relative w-full max-w-[190px] shrink-0 overflow-hidden rounded-md border border-border bg-background" style="container-type:inline-size" aria-label="Placa personalizada: ' + esc(n) + '"><img src="' + esc(img || '') + '" alt="" class="block h-auto w-full" loading="lazy"><span aria-hidden="true" class="absolute inset-x-[9%] top-[39%] bottom-[17%] flex items-center justify-center overflow-hidden whitespace-nowrap text-center font-extrabold uppercase leading-none text-foreground" style="font-size:' + size + '">' + text + '</span>' +
      (animate ? '<span aria-hidden="true" class="plate-shine" style="animation-delay:' + Math.round(start + chars.length * step + 120) + 'ms"></span>' : '') + '</div>';
  }
  // A animação da placa roda só na primeira vez que aquele nome aparece (não a cada atualização da tela).
  function plateAnimationDue(u) {
    if (u._plateShown === u.plateName) return false;
    u._plateShown = u.plateName;
    return true;
  }
  function GelacarCustomizer(container, mode) {
    var data = window.NP_GELACAR_DATA || { vehicleModels: [], vehicleCategories: [], vehicleColors: [] };
    this.el = container; this.data = data; this.qty = 1; this.units = [emptyGelacar(), emptyGelacar()];
    this.mode = mode || GELACAR_MODE;
    var self = this;
    container.addEventListener('click', function (e) { self.onClick(e); });
    container.addEventListener('change', function (e) { self.onChange(e); });
    container.addEventListener('input', function (e) { self.onInput(e); });
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-plate]')) { e.preventDefault(); var b = e.target.closest('[data-unit]').querySelector('[data-act="confirm-plate"]'); if (b && !b.disabled) b.click(); }
    });
  }
  GelacarCustomizer.prototype.setQty = function (q) { this.qty = Math.max(1, Math.min(2, q)); this.render(); };
  GelacarCustomizer.prototype.choice = function (active, act, value, inner) {
    return '<button type="button" aria-pressed="' + (active ? 'true' : 'false') + '" style="touch-action:pan-y" data-act="' + act + '" data-value="' + esc(value) + '" class="' + CLS.choice + ' ' + (active ? CLS.choiceOn : CLS.choiceOff) + '">' + inner + '</button>';
  };
  GelacarCustomizer.prototype.vselect = function (label, field, value, options, disabled, placeholder) {
    return '<label class="min-w-0"><span class="mb-1.5 block text-[12px] font-bold text-foreground">' + label + (value ? ' ✓' : '') + '</span><span class="relative block">' +
      icon('search', 'pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground') +
      '<select data-field="' + field + '"' + (disabled ? ' disabled' : '') + ' class="' + CLS.select + '"><option value="">' + placeholder + '</option>' +
      options.map(function (o) { return '<option value="' + esc(o) + '"' + (o === value ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') +
      '</select>' + icon('chevron-down', 'pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground') + '</span></label>';
  };
  GelacarCustomizer.prototype.unitHtml = function (u, i, showLabel) {
    var d = this.data, self = this;
    var models = d.vehicleModels || [];
    var brands = Array.from(new Set(models.filter(function (m) { return m.category === u.category; }).map(function (m) { return m.brand; }))).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); });
    var modelOptions = models.filter(function (m) { return m.category === u.category && m.brand === u.brand; }).map(function (m) { return m.name; }).sort(function (a, b) { return a.localeCompare(b, 'pt-BR', { numeric: true }); });
    var now = new Date().getFullYear();
    var years = []; for (var y = now; y > 1989; y--) years.push(String(y));
    var ready = gelacarReady(u), complete = gelacarComplete(u);
    if (!u.confirmed) u._plateShown = '';
    var h = '<div data-unit="' + i + '" style="touch-action:pan-y;overflow-anchor:none" class="' + (showLabel ? 'mt-4 rounded-md border border-[hsl(var(--store-blue))]/20 bg-[hsl(var(--store-blue))]/[0.03] p-3.5 sm:p-4' : 'mt-4 border-t border-border pt-4') + '">';
    if (showLabel) {
      h += '<div class="mb-3 flex items-center justify-between gap-2"><span class="rounded bg-[hsl(var(--store-blue))] px-2.5 py-1 text-[11px] font-bold uppercase text-primary-foreground">Unidade ' + (i + 1) + '</span>' +
        (complete ? '<span class="flex items-center gap-1 text-[12px] font-bold text-emerald-600">' + icon('badge-check', 'h-4 w-4') + ' Personalizada</span>' : '') + '</div>';
    }
    if (ready && u.collapsed) {
      h += '<div data-summary class="scroll-mt-24 rounded-md border border-[hsl(var(--store-blue))]/25 border-l-4 border-l-[hsl(var(--store-blue))] bg-[hsl(var(--store-blue))]/[0.04] p-3">' +
        '<strong class="text-[11px] font-bold uppercase tracking-wide text-[hsl(var(--store-blue))]">✓ ' + esc(this.mode.summary) + '</strong>' +
        '<p class="mt-1 text-[13px] font-semibold text-foreground">' + esc(u.brand) + ' ' + esc(u.model) + ' · ' + esc(u.year) + ' · ' + esc(u.color) + '</p>' +
        '<p class="text-[12px] text-muted-foreground">' + (u.view === 'front' ? 'Frente' : 'Traseira') + '</p>' +
        (u.confirmed && u.plateName.trim() && this.mode.sizes ? '<div class="mt-3 flex items-center justify-between gap-3 border-t border-border pt-3"><div class="min-w-0"><p class="text-[12px] font-bold text-foreground">Tamanho do ar-condicionado</p><p class="mt-0.5 text-[15px] font-extrabold text-[hsl(var(--store-blue))]">' + esc(u.plateName) + '</p></div><button type="button" data-act="edit-plate" class="' + CLS.link + ' h-auto shrink-0 px-0 py-0.5 text-[12px] font-bold text-[hsl(var(--store-blue))]">Alterar tamanho</button></div>' : '') +
        (u.confirmed && u.plateName.trim() && !this.mode.sizes ? '<div class="mt-3 flex items-center gap-3 border-t border-border pt-3">' + plateHtml(u.plateName, self.plateImage, plateAnimationDue(u)) + '<div class="min-w-0"><p class="text-[12px] font-bold text-foreground">Sua placa</p><p class="mt-0.5 text-[11px] leading-snug text-muted-foreground">O nome vai gravado na placa do seu GelaCar.</p><button type="button" data-act="edit-plate" class="' + CLS.link + ' mt-0.5 h-auto px-0 py-0.5 text-[12px] font-bold text-[hsl(var(--store-blue))]">Alterar nome</button></div></div>' : '') +
        '<button type="button" data-act="expand" class="' + CLS.link + ' mt-1 h-auto px-0 py-1 text-[12px] font-bold text-[hsl(var(--store-blue))]">Alterar veículo</button></div>';
    } else {
      h += '<div class="space-y-4"><div><span class="mb-2 block text-[13px] font-bold text-foreground">Qual lado do seu carro?</span><div class="grid grid-cols-2 gap-2">' +
        this.choice(u.view === 'front', 'view', 'front', 'Frente') + this.choice(u.view === 'rear', 'view', 'rear', 'Traseira') + '</div></div>';
      h += '<div><span class="mb-2 block text-[13px] font-bold text-foreground">Qual o tipo?</span><div class="grid grid-cols-2 gap-2 min-[370px]:grid-cols-3">' +
        (d.vehicleCategories || []).map(function (c) { return self.choice(u.category === c.id, 'category', c.id, esc(c.label)); }).join('') + '</div></div>';
      if (u.category) {
        h += '<div><span class="mb-2 block text-[13px] font-bold text-foreground">Encontre seu carro</span>';
        if (u.manual) {
          h += '<div class="grid gap-3 sm:grid-cols-2">' + ['brand', 'model', 'year'].map(function (f) {
            return '<label class="min-w-0"><span class="mb-1.5 block text-[12px] font-bold capitalize text-foreground">' + (f === 'brand' ? 'Marca' : f === 'model' ? 'Modelo' : 'Ano') + '</span>' +
              '<input data-manual="' + f + '" value="' + esc(u[f]) + '" maxlength="' + (f === 'year' ? 4 : 80) + '" inputmode="' + (f === 'year' ? 'numeric' : 'text') + '" class="' + CLS.manualInput + '"></label>';
          }).join('') + '</div>';
        } else {
          h += '<div class="grid gap-3 sm:grid-cols-2">' +
            this.vselect('Marca', 'brand', u.brand, brands, false, 'Selecione a marca') +
            this.vselect('Modelo', 'model', u.model, modelOptions, !u.brand, 'Selecione o modelo') +
            this.vselect('Ano', 'year', u.year, years, !u.model, 'Selecione o ano') + '</div>';
        }
        h += '<button type="button" data-act="manual" class="' + CLS.link + ' mt-1 h-auto px-0 py-2 text-[12px] font-bold text-[hsl(var(--store-blue))]">' + (u.manual ? 'Voltar à lista de veículos' : 'Não encontrou? Informe manualmente') + '</button></div>';
      }
      if (u.year) {
        h += '<div><span class="mb-2 block text-[13px] font-bold text-foreground">Qual a cor do seu carro?</span><div class="grid grid-cols-2 gap-2 min-[370px]:grid-cols-3 sm:grid-cols-5">' +
          (d.vehicleColors || []).map(function (c) {
            return self.choice(u.color === c, 'color', c, '<span class="h-4 w-4 shrink-0 rounded-full border border-foreground/20" style="background-color:' + (GELACAR_COLORS[c] || '#ccc') + '"></span>' + esc(c));
          }).join('') + '</div></div>';
      }
      if (ready) h += '<button type="button" data-act="collapse" class="' + CLS.link + ' h-auto px-0 py-1 text-[12px] font-bold text-[hsl(var(--store-blue))]">Concluir veículo</button>';
      h += '</div>';
    }
    if (ready && !(u.collapsed && u.confirmed) && this.mode.sizes) {
      // Capa: no lugar do nome da placa, o cliente escolhe o tamanho do ar-condicionado.
      h += '<div data-plate-wrap class="mt-4 scroll-mt-24"><span class="block text-[13px] font-bold text-foreground">Qual o tamanho do seu ar-condicionado?</span>' +
        '<p class="mt-1 text-[12px] text-muted-foreground">Escolha a potência do aparelho para a capa servir certinho.</p>' +
        '<div class="mt-2 grid grid-cols-2 gap-2 min-[370px]:grid-cols-3">' +
        this.mode.sizes.map(function (sz) { return self.choice(u.confirmed && u.plateName === sz, 'size', sz, esc(sz)); }).join('') + '</div></div>';
    } else if (ready && !(u.collapsed && u.confirmed)) {
      h += '<div data-plate-wrap class="mt-4 scroll-mt-24"><label for="gelacar-plate-' + i + '" class="text-[13px] font-bold text-foreground">Personalize sua placa</label>';
      if (u.confirmed) {
        h += '<div class="mt-2">' + plateHtml(u.plateName, self.plateImage, plateAnimationDue(u)) + '<button type="button" data-act="edit-plate" class="' + CLS.link + ' mt-1 h-auto px-0 py-1 text-[12px] font-bold text-[hsl(var(--store-blue))]">Alterar nome</button></div>';
      } else {
        h += '<p class="mt-1 text-[12px] text-muted-foreground">Digite o nome que você quer na placa.</p>' +
          '<div class="mt-2 flex h-12 overflow-hidden rounded-md border border-input bg-background focus-within:border-[hsl(var(--store-blue))] focus-within:ring-2 focus-within:ring-[hsl(var(--store-blue))]/15">' +
          '<input id="gelacar-plate-' + i + '" data-plate value="' + esc(u.plateName) + '" maxlength="40" autocomplete="off" placeholder="SEU NOME" class="min-w-0 flex-1 border-0 bg-transparent px-3 text-center text-base font-bold uppercase outline-none"></div>' +
          '<button type="button" data-act="confirm-plate"' + (u.plateName.trim() ? '' : ' disabled') + ' class="' + CLS.confirmPlate + '">' + icon('check', 'h-4 w-4') + ' Confirmar nome da placa</button>';
      }
      h += '</div>';
    }
    return h + '</div>';
  };
  GelacarCustomizer.prototype.render = function () {
    var n = this.qty, html = '';
    for (var i = 0; i < n; i++) html += this.unitHtml(this.units[i], i, n > 1);
    this.el.innerHTML = '<section class="mt-6 rounded-md border border-border border-t-4 border-t-[hsl(var(--store-blue))] bg-background p-4 sm:p-5" aria-label="' + esc(this.mode.title) + '"><div><h2 class="text-[15px] font-extrabold uppercase text-foreground">' + esc(this.mode.title) + '</h2></div>' +
      '<p class="mt-1 text-[13px] text-muted-foreground">Escolha seu carro e deixe ele com a sua cara.</p>' + html + '</section>';
  };
  GelacarCustomizer.prototype.patch = function (i, values) {
    var u = this.units[i];
    Object.keys(values).forEach(function (k) { u[k] = values[k]; });
    // Na capa, trocar o carro não apaga o tamanho já escolhido.
    if (!('confirmed' in values) && !this.mode.sizes) u.confirmed = false;
  };
  GelacarCustomizer.prototype.onClick = function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var unitEl = b.closest('[data-unit]'); var i = Number(unitEl.getAttribute('data-unit')); var u = this.units[i];
    var act = b.getAttribute('data-act'), v = b.getAttribute('data-value'), self = this;
    if (act === 'view') { this.patch(i, { view: v }); keepViewportStill(function () { self.render(); }); }
    else if (act === 'category') { this.patch(i, { category: v, brand: '', model: '', year: '', color: '' }); keepViewportStill(function () { self.render(); }); }
    else if (act === 'manual') { this.patch(i, { manual: !u.manual, brand: '', model: '', year: '', color: '' }); keepViewportStill(function () { self.render(); }); }
    else if (act === 'color') { this.patch(i, { color: v }); this.collapse(i); }
    else if (act === 'collapse') { this.collapse(i); }
    else if (act === 'expand') { u.collapsed = false; keepViewportStill(function () { self.render(); }); }
    else if (act === 'confirm-plate') {
      if (!u.plateName.trim()) return;
      // Fecha o teclado e leva a tela até a placa pronta.
      confirmAndReveal(function () { u.plateName = u.plateName.trim(); u.confirmed = true; self.render(); }, function () {
        var unit = self.el.querySelector('[data-unit="' + i + '"]');
        return unit && (unit.querySelector('[data-summary]') || unit.querySelector('[data-plate-wrap]') || unit);
      });
    }
    else if (act === 'size') {
      // Leva a tela até o resumo com o tamanho escolhido.
      confirmAndReveal(function () { u.plateName = v; u.confirmed = true; self.render(); }, function () {
        var unit = self.el.querySelector('[data-unit="' + i + '"]');
        return unit && (unit.querySelector('[data-summary]') || unit.querySelector('[data-plate-wrap]') || unit);
      });
    }
    else if (act === 'edit-plate' && this.mode.sizes) {
      u.confirmed = false; self.render();
      var wrap = self.el.querySelector('[data-unit="' + i + '"] [data-plate-wrap]');
      if (wrap) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    else if (act === 'edit-plate') {
      // Volta a editar o nome já com o campo selecionado (abre o teclado).
      u.confirmed = false; self.render();
      var input = self.el.querySelector('#gelacar-plate-' + i);
      if (input) { input.focus(); input.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }
  };
  GelacarCustomizer.prototype.collapse = function (i) {
    this.units[i].collapsed = true;
    var self = this;
    keepViewportStill(function () { self.render(); });
    requestAnimationFrame(function () {
      var s = self.el.querySelector('[data-unit="' + i + '"] [data-summary]');
      if (s) s.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  };
  GelacarCustomizer.prototype.onChange = function (e) {
    var t = e.target; if (!t.matches('select[data-field]')) return;
    var i = Number(t.closest('[data-unit]').getAttribute('data-unit')); var f = t.getAttribute('data-field'); var self = this;
    if (f === 'brand') this.patch(i, { brand: t.value, model: '', year: '', color: '' });
    if (f === 'model') this.patch(i, { model: t.value, year: '', color: '' });
    if (f === 'year') this.patch(i, { year: t.value, color: '' });
    keepViewportStill(function () { self.render(); });
  };
  GelacarCustomizer.prototype.onInput = function (e) {
    var t = e.target; var unitEl = t.closest('[data-unit]'); if (!unitEl) return;
    var i = Number(unitEl.getAttribute('data-unit')); var u = this.units[i];
    if (t.matches('[data-plate]')) {
      var pos = t.selectionStart; t.value = t.value.toUpperCase(); try { t.setSelectionRange(pos, pos); } catch (err) {}
      u.plateName = t.value; u.confirmed = false;
      var btn = unitEl.querySelector('[data-act="confirm-plate"]'); if (btn) btn.disabled = !u.plateName.trim();
    } else if (t.matches('[data-manual]')) {
      var f = t.getAttribute('data-manual');
      var val = f === 'year' ? t.value.replace(/\D/g, '') : t.value;
      if (f === 'year') t.value = val;
      var hadYear = !!u.year, wasReady = gelacarReady(u);
      u[f] = val; u.confirmed = false;
      // Re-renderiza só quando a próxima etapa aparece/some, mantendo o foco no campo.
      if (hadYear !== !!u.year || wasReady !== gelacarReady(u)) {
        var caret = t.selectionStart;
        this.render();
        var again = this.el.querySelector('[data-unit="' + i + '"] [data-manual="' + f + '"]');
        if (again) { again.focus(); try { again.setSelectionRange(caret, caret); } catch (err2) {} }
      }
    }
  };
  GelacarCustomizer.prototype.firstIncomplete = function () {
    for (var i = 0; i < this.qty; i++) if (!gelacarComplete(this.units[i])) return i;
    return -1;
  };
  GelacarCustomizer.prototype.validate = function () {
    for (var i = 0; i < this.qty; i++) {
      if (!gelacarComplete(this.units[i])) return this.qty > 1 ? 'Complete a personalização da unidade ' + (i + 1) + '.' : this.mode.incomplete;
    }
    return null;
  };
  // A sacola monta o texto a partir destas propriedades (sem _label, que o checkout mostrava duplicado).
  GelacarCustomizer.prototype.properties = function () {
    var props = {};
    for (var i = 0; i < this.qty; i++) props['Unidade ' + (i + 1)] = gelacarValue(this.units[i], this.mode);
    return props;
  };

  /* ---------- GelaTruck ---------- */
  var TRUCK_COLORS = { Branco: '#f7f7f5', Preto: '#24272a', Prata: '#c4c8c9', Cinza: '#7c8589', Azul: '#326aa3', Vermelho: '#cc3939', Verde: '#318050', Bege: '#d2bea0', Marrom: '#795641' };
  function emptyTruck() { return { brand: '', model: '', color: '', plateName: '', confirmed: false, editing: true }; }
  function truckComplete(u, assumeConfirmed) { return !!(u.brand && u.model && u.color && u.plateName.trim() && (assumeConfirmed || u.confirmed)); }
  function GelatruckCustomizer(container) {
    this.el = container; this.qty = 1; this.units = [emptyTruck(), emptyTruck(), emptyTruck()];
    this.data = (window.NP_GELATRUCK_DATA && window.NP_GELATRUCK_DATA.caminhoes) || {};
    var self = this;
    container.addEventListener('click', function (e) { self.onClick(e); });
    container.addEventListener('change', function (e) { self.onChange(e); });
    container.addEventListener('input', function (e) { self.onInput(e); });
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-plate]')) { e.preventDefault(); var b = e.target.closest('[data-unit]').querySelector('[data-act="confirm"]'); if (b && !b.disabled) b.click(); }
    });
  }
  GelatruckCustomizer.prototype.setQty = function (q) { this.qty = Math.max(1, Math.min(3, q)); this.render(); };
  GelatruckCustomizer.prototype.unitHtml = function (u, i, showLabel) {
    var data = this.data;
    var brands = Object.keys(data).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); });
    var models = u.brand ? Object.keys(data[u.brand] || {}).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); }) : [];
    if (!u.confirmed || u.editing) u._plateShown = '';
    if (u.confirmed && !u.editing) {
      return '<div data-unit="' + i + '" class="scroll-mt-24 ' + (showLabel ? 'mt-4 rounded-md border border-[hsl(var(--store-blue))]/20 p-3.5' : 'mt-4') + '">' +
        (showLabel ? '<span class="mb-2 inline-block rounded bg-[hsl(var(--store-blue))] px-2.5 py-1 text-[11px] font-bold uppercase text-primary-foreground">Unidade ' + (i + 1) + '</span>' : '') +
        '<div class="rounded-md border border-[hsl(var(--store-blue))]/25 border-l-4 border-l-[hsl(var(--store-blue))] bg-[hsl(var(--store-blue))]/[0.04] p-3">' +
        '<strong class="flex items-center gap-1.5 text-[12px] font-extrabold uppercase text-[hsl(var(--store-blue))]">' + icon('check', 'h-4 w-4') + ' Excelente escolha!</strong>' +
        '<p class="mt-1 text-[14px] font-bold text-foreground">' + esc(u.brand) + ' ' + esc(u.model) + '</p>' +
        '<p class="text-[12px] text-muted-foreground">' + esc(u.color) + ' · Placa: <span class="font-bold uppercase text-emerald-700">' + esc(u.plateName) + '</span></p>' +
        '<div class="mt-3 flex items-center gap-3 border-t border-border pt-3">' + plateHtml(u.plateName, this.plateImage, plateAnimationDue(u)) + '<div class="min-w-0"><p class="text-[12px] font-bold text-foreground">Sua placa</p><p class="mt-0.5 text-[11px] leading-snug text-muted-foreground">O nome vai gravado na placa do seu GelaTruck.</p></div></div>' +
        '<button type="button" data-act="edit" class="' + CLS.link + ' mt-1 h-auto px-0 py-1 text-[12px] font-bold text-[hsl(var(--store-blue))]">← Alterar configuração</button></div></div>';
    }
    var h = '<div data-unit="' + i + '" style="touch-action:pan-y;overflow-anchor:none" class="' + (showLabel ? 'mt-5 rounded-md border border-border p-3.5 sm:p-4' : 'mt-5') + '">';
    if (showLabel) h += '<div class="mb-3 flex items-center justify-between gap-2"><span class="rounded bg-[hsl(var(--store-blue))] px-2.5 py-1 text-[11px] font-bold uppercase text-primary-foreground">Unidade ' + (i + 1) + '</span>' + (u.confirmed ? '<span class="flex items-center gap-1 text-[12px] font-bold text-emerald-600">' + icon('badge-check', 'h-4 w-4') + ' Configurado</span>' : '') + '</div>';
    h += '<div class="grid gap-3 sm:grid-cols-2">' +
      '<label class="block min-w-0"><span class="mb-1.5 block text-[13px] font-semibold text-foreground">Marca</span><select data-field="brand" class="' + CLS.truckSelect + '"><option value="">Selecione a marca</option>' + brands.map(function (b) { return '<option' + (b === u.brand ? ' selected' : '') + '>' + esc(b) + '</option>'; }).join('') + '</select></label>' +
      '<label class="block min-w-0"><span class="mb-1.5 block text-[13px] font-semibold text-foreground">Modelo</span><select data-field="model" class="' + CLS.truckSelect + '"' + (u.brand ? '' : ' disabled') + '><option value="">Selecione o modelo</option>' + models.map(function (m) { return '<option' + (m === u.model ? ' selected' : '') + '>' + esc(m) + '</option>'; }).join('') + '</select></label></div>';
    if (u.brand && u.model) {
      h += '<div class="mt-5"><span class="mb-2 block text-[13px] font-semibold text-foreground">Qual a cor do seu caminhão?</span><div class="grid grid-cols-2 gap-2 min-[380px]:grid-cols-3">' +
        Object.keys(TRUCK_COLORS).map(function (c) {
          return '<button type="button" data-act="color" data-value="' + c + '" aria-pressed="' + (u.color === c) + '" class="' + CLS.truckColor + ' ' + (u.color === c ? CLS.truckColorOn : CLS.truckColorOff) + '"><span class="h-[18px] w-[18px] shrink-0 rounded-full border border-foreground/20" style="background-color:' + TRUCK_COLORS[c] + '"></span>' + c + '</button>';
        }).join('') + '</div></div>';
    }
    if (u.color) {
      h += '<div class="mt-5"><label class="block min-w-0"><span class="mb-1.5 block text-[13px] font-semibold text-foreground">Nome para personalizar a placa</span><input data-plate value="' + esc(u.plateName) + '" maxlength="18" autocomplete="off" placeholder="Ex.: MATHEUS" class="' + CLS.truckSelect + '"><span class="mt-1 block text-[11px] text-muted-foreground">Digite como deseja que apareça na placa do seu GelaTruck.</span></label></div>';
    }
    h += '<button type="button" data-act="confirm"' + (truckComplete(u, true) ? '' : ' disabled') + ' class="' + CLS.confirmVehicle + '">' + icon('check', 'h-4 w-4') + ' Confirmar veículo</button></div>';
    return h;
  };
  GelatruckCustomizer.prototype.render = function () {
    var html = '';
    for (var i = 0; i < this.qty; i++) html += this.unitHtml(this.units[i], i, this.qty > 1);
    this.el.innerHTML = '<section class="mt-6 rounded-md border border-border border-t-[5px] border-t-primary bg-background p-4 shadow-sm sm:p-6" aria-label="Configure seu GelaTruck"><div><h2 class="text-[14px] font-bold uppercase text-foreground">Personalize seu GelaTruck</h2><p class="mt-1 text-[13px] text-muted-foreground">Escolha seu caminhão e deixe ele com a sua cara.</p></div>' + html + '</section>';
  };
  GelatruckCustomizer.prototype.onClick = function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var i = Number(b.closest('[data-unit]').getAttribute('data-unit')); var u = this.units[i]; var self = this;
    var act = b.getAttribute('data-act');
    if (act === 'color') { u.color = b.getAttribute('data-value'); u.confirmed = false; keepViewportStill(function () { self.render(); }); }
    else if (act === 'confirm') {
      if (!truckComplete(u, true)) return;
      // Fecha o teclado e leva a tela até o resumo "Excelente escolha!".
      confirmAndReveal(function () { u.plateName = u.plateName.trim().toUpperCase(); u.confirmed = true; u.editing = false; self.render(); }, function () {
        return self.el.querySelector('[data-unit="' + i + '"]');
      });
    } else if (act === 'edit') { u.editing = true; this.render(); }
  };
  GelatruckCustomizer.prototype.onChange = function (e) {
    var t = e.target; if (!t.matches('select[data-field]')) return;
    var i = Number(t.closest('[data-unit]').getAttribute('data-unit')); var u = this.units[i]; var self = this;
    if (t.getAttribute('data-field') === 'brand') { u.brand = t.value; u.model = ''; u.color = ''; }
    else { u.model = t.value; u.color = ''; }
    u.confirmed = false;
    keepViewportStill(function () { self.render(); });
  };
  GelatruckCustomizer.prototype.onInput = function (e) {
    var t = e.target; if (!t.matches('[data-plate]')) return;
    var unitEl = t.closest('[data-unit]'); var u = this.units[Number(unitEl.getAttribute('data-unit'))];
    var pos = t.selectionStart; t.value = t.value.toUpperCase(); try { t.setSelectionRange(pos, pos); } catch (err) {}
    u.plateName = t.value; u.confirmed = false;
    var btn = unitEl.querySelector('[data-act="confirm"]'); if (btn) btn.disabled = !truckComplete(u, true);
  };
  GelatruckCustomizer.prototype.firstIncomplete = function () {
    for (var i = 0; i < this.qty; i++) if (!truckComplete(this.units[i])) return i;
    return -1;
  };
  GelatruckCustomizer.prototype.validate = function () {
    for (var i = 0; i < this.qty; i++) if (!truckComplete(this.units[i])) return this.qty > 1 ? 'Complete a personalização da unidade ' + (i + 1) + '.' : 'Complete a personalização do seu GelaTruck.';
    return null;
  };
  GelatruckCustomizer.prototype.properties = function () {
    var props = {};
    for (var i = 0; i < this.qty; i++) {
      var u = this.units[i];
      props['Unidade ' + (i + 1)] = u.brand + ' ' + u.model + ' • ' + u.color + ' • Placa: ' + u.plateName.trim();
    }
    return props;
  };

  /* ---------- TruckBar / AutoBar ---------- */
  function resizePhoto(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        // 1280px é suficiente como referência e deixa o envio ao carrinho mais rápido no 4G.
        var scale = Math.min(1, 1280 / Math.max(img.naturalWidth, img.naturalHeight));
        var canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        canvas.toBlob(function (blob) {
          if (!blob || blob.size > 2 * 1024 * 1024) reject(new Error('Foto grande demais. Escolha outra imagem.'));
          else resolve(blob);
        }, 'image/jpeg', 0.72);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Não foi possível preparar a foto.')); };
      img.src = url;
    });
  }
  /*
   * Personalizador dos dispensers. TruckBar/AutoBar: posto + nome (opcional) + foto do veículo (opcional).
   * AgroBar/MaqBar (personalização "nome"): só o nome, obrigatório.
   */
  function BarCustomizer(container, opts) {
    this.el = container; this.qty = 1;
    this.productName = opts.productName;
    this.vehicle = opts.vehicle || '';
    this.stations = opts.stations || [];
    this.nameRequired = !!opts.nameRequired;
    this.units = [];
    var self = this;
    container.addEventListener('click', function (e) { self.onClick(e); });
    container.addEventListener('change', function (e) { self.onFile(e); });
    container.addEventListener('input', function (e) {
      if (!e.target.matches('[data-name]')) return;
      self.unit(Number(e.target.closest('[data-unit]').getAttribute('data-unit'))).name = e.target.value;
    });
    // Enter no nome não pode enviar o formulário do produto (iria para o carrinho sem querer).
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-name]')) { e.preventDefault(); e.target.blur(); }
    });
  }
  BarCustomizer.prototype.unit = function (i) { while (this.units.length <= i) this.units.push({ station: '', name: '', blob: null, preview: '', busy: false }); return this.units[i]; };
  BarCustomizer.prototype.setQty = function (q) { this.qty = Math.max(1, q); this.render(); };
  BarCustomizer.prototype.unitHtml = function (i) {
    var u = this.unit(i), v = this.vehicle, self = this;
    var unitLabel = this.qty > 1 ? 'Unidade ' + (i + 1) : '';
    var done = !!u.blob && !u.busy;
    var h = '<section data-unit="' + i + '" class="space-y-5 ' + (unitLabel ? 'mt-4 rounded-2xl border border-[hsl(var(--store-blue))]/20 bg-[hsl(var(--store-blue))]/[0.03] p-3.5 sm:p-4' : 'mt-6 border-t border-border pt-5') + '" aria-label="Personalização do ' + this.productName + (unitLabel ? ' — ' + unitLabel : '') + '">';
    if (unitLabel) h += '<div class="flex items-center gap-2"><span class="rounded-full bg-[hsl(var(--store-blue))] px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide text-white">' + unitLabel + '</span><span class="text-[12px] font-medium text-muted-foreground">Personalize este ' + this.productName + '</span></div>';
    if (this.stations.length) {
      h += '<div><h2 class="text-base font-bold text-foreground">Escolha seu posto</h2><div class="mt-3 grid grid-cols-5 gap-1.5 sm:gap-2">' +
        this.stations.map(function (s) {
          var on = u.station === s.name;
          return '<button type="button" data-act="station" data-value="' + esc(s.name) + '" aria-pressed="' + on + '" class="' + CLS.station + ' ' + (on ? CLS.stationOn : CLS.stationOff) + '">' +
            (on ? icon('check', 'absolute right-1 top-1 h-3 w-3 text-[hsl(var(--store-blue))]') : '') +
            '<img src="' + s.logo + '" alt="" class="h-8 w-full object-contain px-1" loading="lazy"><span class="w-full truncate text-center text-[10px] font-semibold text-foreground sm:text-xs">' + esc(s.name) + '</span></button>';
        }).join('') + '</div></div>';
    }
    h += '<div><h2 class="text-base font-bold text-foreground">Nome para personalizar' + (this.nameRequired ? '' : ' <span class="text-sm font-normal text-muted-foreground">(opcional)</span>') + '</h2>' +
      '<input data-name value="' + esc(u.name) + '" maxlength="18" autocomplete="off" placeholder="Ex.: EDUARDO" aria-label="Nome para personalizar o ' + this.productName + '" class="mt-3 ' + CLS.truckSelect + '">' +
      '<p class="mt-1 text-[11px] text-muted-foreground">Digite como deseja que o nome apareça no seu ' + this.productName + '.</p></div>';
    if (!v) return h + '</section>';
    h += '<div><h2 class="text-base font-bold text-foreground">Foto do seu ' + v + ' <span class="text-sm font-normal text-muted-foreground">(opcional)</span></h2>' +
      '<div class="mt-3 rounded-2xl border border-dashed p-4 transition-colors ' + (done ? 'border-[hsl(142_71%_45%)]/50 bg-gradient-to-br from-[hsl(142_71%_45%)]/[0.08] to-[hsl(var(--store-blue))]/[0.02]' : 'border-[hsl(var(--store-blue))]/45 bg-gradient-to-br from-[hsl(var(--store-blue))]/[0.08] to-[hsl(var(--store-blue))]/[0.02]') + '">' +
      '<button type="button" data-act="pick"' + (u.busy ? ' disabled' : '') + ' class="flex w-full items-center gap-4 rounded-xl text-left transition-opacity hover:opacity-90 disabled:cursor-wait"><span class="relative shrink-0">' +
      (u.preview ? '<img src="' + u.preview + '" alt="Foto enviada do ' + v + '" class="h-[76px] w-[76px] rounded-xl border-2 object-cover shadow-sm ' + (done ? 'border-[hsl(142_71%_45%)]/60' : 'border-[hsl(var(--store-blue))]/35') + '">'
        : '<span class="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-[hsl(var(--store-blue))]/10 ring-1 ring-[hsl(var(--store-blue))]/30">' + icon('camera', 'h-6 w-6 text-[hsl(var(--store-blue))]', 2.2) + '</span>') +
      (done ? '<span class="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-[hsl(142_71%_45%)] text-white shadow-md" aria-label="Foto enviada">' + icon('check', 'h-3.5 w-3.5', 3) + '</span>' : '') +
      '</span><span class="min-w-0 flex-1"><span class="flex items-center gap-1.5 text-[15px] font-extrabold tracking-tight ' + (done ? 'text-[hsl(142_71%_38%)]' : 'text-foreground') + '">' +
      (u.busy ? 'Enviando foto…' : done ? 'Foto enviada' : 'Envie a foto do seu ' + v) + (done ? icon('check', 'h-4 w-4', 3) : '') + '</span>' +
      '<span class="mt-0.5 block text-[12.5px] leading-snug text-muted-foreground">' + (u.busy ? 'Um instante, estamos preparando sua foto…' : done ? 'Sua foto está garantida no pedido. Toque nela se quiser enviar outra.' : 'Opcional: envie a foto do seu ' + v + ' para usarmos de referência.') + '</span></span>' +
      (u.busy ? icon('loader-circle', 'h-5 w-5 shrink-0 animate-spin text-[hsl(var(--store-blue))]') : '') + '</button>' +
      (done ? '<div class="mt-3 flex justify-end"><button type="button" data-act="remove-photo" class="' + CLS.removePhoto + '">' + icon('x', 'h-3.5 w-3.5') + ' Remover foto</button></div>' : '') +
      '</div><input type="file" accept="image/*" class="hidden" aria-label="Foto do ' + v + '" data-file></div></section>';
    return h;
  };
  BarCustomizer.prototype.render = function () {
    var html = ''; for (var i = 0; i < this.qty; i++) html += this.unitHtml(i);
    this.el.innerHTML = html;
  };
  BarCustomizer.prototype.onClick = function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var i = Number(b.closest('[data-unit]').getAttribute('data-unit')); var u = this.unit(i); var self = this;
    var act = b.getAttribute('data-act');
    if (act === 'station') { u.station = b.getAttribute('data-value'); keepViewportStill(function () { self.render(); }); }
    else if (act === 'pick') { var input = b.closest('[data-unit]').querySelector('[data-file]'); if (input) input.click(); }
    else if (act === 'remove-photo') { if (u.preview) URL.revokeObjectURL(u.preview); u.blob = null; u.preview = ''; this.render(); }
  };
  BarCustomizer.prototype.onFile = function (e) {
    var t = e.target; if (!t.matches('[data-file]')) return;
    var file = t.files && t.files[0]; if (!file) return;
    var i = Number(t.closest('[data-unit]').getAttribute('data-unit')); var u = this.unit(i); var self = this;
    if (!/^image\//.test(file.type)) { toast('Escolha uma foto do ' + this.vehicle + '.'); return; }
    if (file.size > 12 * 1024 * 1024) { toast('Escolha uma foto de até 12 MB.'); return; }
    if (u.preview) URL.revokeObjectURL(u.preview);
    u.preview = URL.createObjectURL(file); u.busy = true; u.blob = null; this.render();
    resizePhoto(file).then(function (blob) {
      u.blob = blob; u.busy = false; self.render();
      toast('Foto do ' + self.vehicle + ' enviada.', 'success');
    }).catch(function (err) {
      u.busy = false; u.preview = ''; self.render();
      toast(err.message || 'Não foi possível enviar a foto.');
    });
  };
  // O que falta na unidade: '' quando está completa.
  BarCustomizer.prototype.missing = function (i) {
    var u = this.unit(i);
    var unit = this.qty > 1 ? ' da unidade ' + (i + 1) : '';
    if (u.busy) return 'Aguarde o envio da foto.';
    if (this.stations.length && !u.station) return 'Escolha o posto' + unit + ' para personalizar o ' + this.productName + '.';
    if (this.nameRequired && !u.name.trim()) return 'Digite o nome' + unit + ' para personalizar o ' + this.productName + '.';
    return '';
  };
  BarCustomizer.prototype.firstIncomplete = function () {
    for (var i = 0; i < this.qty; i++) if (this.missing(i)) return i;
    return -1;
  };
  BarCustomizer.prototype.validate = function () {
    var i = this.firstIncomplete();
    return i < 0 ? null : this.missing(i);
  };
  BarCustomizer.prototype.properties = function () {
    var props = {}, files = {};
    var photoLabel = 'Foto do ' + this.vehicle;
    for (var i = 0; i < this.qty; i++) {
      var u = this.unit(i), head = this.qty > 1 ? 'Unidade ' + (i + 1) + ' - ' : '';
      if (this.stations.length) props[head + 'Posto'] = u.station;
      if (u.name.trim()) props[head + 'Nome'] = u.name.trim();
      if (u.blob) files[head + photoLabel] = u.blob;
    }
    return { props: props, files: files };
  };

  /*
   * UmidCar (personalização "umidcar"): marca e modelo do carro. Como na loja original, uma escolha só vale
   * para o kit inteiro e vai no pedido como "Carro: <marca> <modelo>".
   */
  function CarPickCustomizer(container, opts) {
    this.el = container; this.qty = 1;
    this.productName = opts.productName;
    this.data = (window.NP_UMIDCAR_DATA && window.NP_UMIDCAR_DATA.carros) || {};
    this.brand = ''; this.model = '';
    var self = this;
    container.addEventListener('change', function (e) {
      var t = e.target; if (!t.matches('select[data-field]')) return;
      if (t.getAttribute('data-field') === 'brand') { self.brand = t.value; self.model = ''; }
      else self.model = t.value;
      keepViewportStill(function () { self.render(); });
    });
  }
  CarPickCustomizer.prototype.setQty = function (q) { this.qty = Math.max(1, q); this.render(); };
  CarPickCustomizer.prototype.selectHtml = function (field, label, value, options, placeholder, disabled) {
    return '<label class="min-w-0"><span class="mb-1.5 block text-[12px] font-bold text-foreground">' + label + (value ? ' ✓' : '') + '</span>' +
      '<span class="relative block">' + icon('search', 'pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground') +
      '<select data-field="' + field + '"' + (disabled ? ' disabled' : '') + ' class="h-11 w-full appearance-none rounded-md border border-input bg-background pl-9 pr-8 text-base font-medium text-foreground outline-none focus:border-[hsl(var(--store-blue))] focus:ring-2 focus:ring-[hsl(var(--store-blue))]/15 disabled:cursor-not-allowed disabled:opacity-45">' +
      '<option value="">' + placeholder + '</option>' +
      options.map(function (o) { return '<option' + (o === value ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') + '</select>' +
      icon('chevron-down', 'pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground') + '</span></label>';
  };
  CarPickCustomizer.prototype.render = function () {
    var data = this.data;
    var brands = Object.keys(data).sort(function (a, b) { return a.localeCompare(b, 'pt-BR'); });
    var models = this.brand ? (data[this.brand] || []).slice().sort(function (a, b) { return a.localeCompare(b, 'pt-BR', { numeric: true }); }) : [];
    this.el.innerHTML = '<section class="mt-6 scroll-mt-24 rounded-md border border-border border-t-4 border-t-[hsl(var(--store-blue))] bg-background p-4 sm:p-5" aria-label="Escolha seu carro">' +
      '<div><h2 class="text-[15px] font-extrabold uppercase text-foreground">Escolha seu carro</h2></div>' +
      '<p class="mt-1 text-[13px] text-muted-foreground">Selecione a marca e o modelo para o seu ' + esc(this.productName) + '.</p>' +
      '<div class="mt-4 grid gap-3 sm:grid-cols-2">' +
      this.selectHtml('brand', 'Marca', this.brand, brands, 'Selecione a marca', false) +
      this.selectHtml('model', 'Modelo', this.model, models, 'Selecione o modelo', !this.brand) +
      '</div></section>';
  };
  CarPickCustomizer.prototype.firstIncomplete = function () { return this.brand && this.model ? -1 : 0; };
  CarPickCustomizer.prototype.validate = function () {
    return this.firstIncomplete() < 0 ? null : 'Selecione a marca e o modelo do seu carro.';
  };
  CarPickCustomizer.prototype.properties = function () {
    return { Carro: this.brand + ' ' + this.model };
  };

  /* AutoCharge: seleção dependente de marca/modelo/cor + confirmação explícita.
     Usa propriedades de linha enviadas pelo AJAX do tema, sem depender de formulários ocultos.
     Uma seleção personalizada se aplica ao kit selecionado (1 ou 2 unidades). */
  function AutochargeCustomizer(container) {
    this.el = container;
    this.qty = 1;
    this.data = (window.NP_AUTOCHARGE_DATA && window.NP_AUTOCHARGE_DATA.carros) || {};
    this.colors = (window.NP_AUTOCHARGE_DATA && window.NP_AUTOCHARGE_DATA.cores) || [];
    this.brand = '';
    this.model = '';
    this.color = '';
    this.otherModel = '';
    this.otherColor = '';
    this.confirmed = false;
    var self = this;
    container.addEventListener('change', function (e) {
      var target = e.target;
      if (!target.matches('[data-autocharge-field]')) return;
      var field = target.getAttribute('data-autocharge-field');
      if (field === 'brand') {
        self.brand = target.value;
        self.model = '';
        self.otherModel = '';
      } else if (field === 'model') {
        self.model = target.value;
        self.otherModel = '';
      } else if (field === 'color') {
        self.color = target.value;
        self.otherColor = '';
      } else if (field === 'otherModel') self.otherModel = target.value;
      else if (field === 'otherColor') self.otherColor = target.value;
      self.confirmed = false;
      keepViewportStill(function () { self.render(); });
    });
    container.addEventListener('input', function (e) {
      var target = e.target;
      if (!target.matches('input[data-autocharge-field]')) return;
      if (target.getAttribute('data-autocharge-field') === 'otherModel') self.otherModel = target.value;
      if (target.getAttribute('data-autocharge-field') === 'otherColor') self.otherColor = target.value;
      self.confirmed = false;
      var note = self.el.querySelector('[data-ac-status]');
      if (note) note.textContent = 'Confirme o veículo para continuar.';
      var section = self.el.querySelector('[data-autocharge-section]');
      if (section) section.setAttribute('data-confirmed', 'false');
    });
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-autocharge-confirm]');
      if (!btn) return;
      var missing = self.missing();
      if (missing) {
        self.confirmed = false;
        toast(missing);
        var first = self.el.querySelector('[data-autocharge-field][required]:invalid');
        if (first) first.focus();
        else {
          var focusField = self.el.querySelector('[data-autocharge-field]');
          if (focusField) focusField.focus();
        }
        return;
      }
      self.confirmed = true;
      self.render();
      var section = self.el.querySelector('[data-autocharge-section]');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }
  AutochargeCustomizer.prototype.setQty = function (qty) {
    this.qty = Math.max(1, Number(qty) || 1);
    this.render();
  };
  AutochargeCustomizer.prototype.finalModel = function () {
    return this.model === '__other__' ? this.otherModel.trim() : this.model;
  };
  AutochargeCustomizer.prototype.finalColor = function () {
    return this.color === '__other__' ? this.otherColor.trim() : this.color;
  };
  AutochargeCustomizer.prototype.missing = function () {
    if (!this.brand) return 'Selecione a marca do carro.';
    if (!this.finalModel()) return 'Selecione ou informe o modelo do carro.';
    if (!this.finalColor()) return 'Selecione ou informe a cor do carro.';
    return null;
  };
  AutochargeCustomizer.prototype.firstIncomplete = function () {
    return this.missing() || !this.confirmed ? 0 : -1;
  };
  AutochargeCustomizer.prototype.validate = function () {
    return this.missing() || (!this.confirmed ? 'Clique em Confirmar veículo antes de comprar.' : null);
  };
  AutochargeCustomizer.prototype.properties = function () {
    return { Marca: this.brand, Modelo: this.finalModel(), Cor: this.finalColor() };
  };
  AutochargeCustomizer.prototype.render = function () {
    var self = this;
    var brands = Object.keys(this.data).sort(function (a,b) { return a.localeCompare(b, 'pt-BR'); });
    var models = this.brand ? (this.data[this.brand] || []).slice().sort(function (a,b) { return a.localeCompare(b, 'pt-BR', { numeric:true }); }) : [];
    function sel(name, label, placeholder, options, value, disabled) {
      return '<label class="np-ac-field"><span>' + label + '</span><select required data-autocharge-field="' + name + '" aria-label="' + label + '"' + (disabled ? ' disabled' : '') + '>' +
        '<option value="">' + placeholder + '</option>' + options.map(function (o) {
          var v = typeof o === 'string' ? o : o.value;
          var t = typeof o === 'string' ? o : o.label;
          return '<option value="' + esc(v) + '"' + (v === value ? ' selected' : '') + '>' + esc(t) + '</option>';
        }).join('') + '</select></label>';
    }
    var modelOptions = models.map(function (x) { return x; });
    modelOptions.push({ value: '__other__', label: 'Outro modelo (informar)' });
    var colorOptions = this.colors.map(function (x) { return x; });
    colorOptions.push({ value: '__other__', label: 'Outra cor (informar)' });
    var msg = this.confirmed
      ? '✓ Confirmado: ' + esc(this.brand) + ' · ' + esc(this.finalModel()) + ' · ' + esc(this.finalColor())
      : 'Confirme o veículo para continuar.';
    this.el.innerHTML = '<section class="np-ac-card" data-autocharge-section data-confirmed="' + this.confirmed + '" aria-label="Personalize seu AutoCharge">' +
      '<div class="np-ac-heading"><span class="np-ac-heading-icon" aria-hidden="true">✦</span><div><h2>Personalize seu AutoCharge</h2><p>Selecione o carro que você quer receber.</p></div></div>' +
      '<div class="np-ac-fields">' +
      sel('brand','Marca','Selecione a marca',brands,this.brand,false) +
      sel('model','Modelo',this.brand ? 'Selecione o modelo' : 'Escolha a marca primeiro',modelOptions,this.model,!this.brand) +
      sel('color','Cor','Selecione a cor',colorOptions,this.color,false) + '</div>' +
      (this.model === '__other__' ? '<label class="np-ac-field np-ac-other">Informe o modelo<input data-autocharge-field="otherModel" required maxlength="80" placeholder="Ex.: 911 Carrera" value="' + esc(this.otherModel) + '"></label>' : '') +
      (this.color === '__other__' ? '<label class="np-ac-field np-ac-other">Informe a cor<input data-autocharge-field="otherColor" required maxlength="60" placeholder="Ex.: Verde escuro" value="' + esc(this.otherColor) + '"></label>' : '') +
      '<button type="button" class="np-ac-confirm" data-autocharge-confirm>' + (this.confirmed ? '✓ Veículo confirmado' : '✓ Confirmar veículo') + '</button>' +
      '<p class="np-ac-status" role="status" aria-live="polite" data-ac-status>' + msg + '</p>' +
      (this.qty > 1 ? '<p class="np-ac-note">O veículo selecionado será usado nas ' + this.qty + ' unidades do kit.</p>' : '') +
      '</section>';
  };

  /* Mostra o que falta: rola até o personalizador e destaca a parte incompleta por um instante. */
  function showMissing(customizer) {
    var root = customizer.el;
    var idx = customizer.firstIncomplete ? customizer.firstIncomplete() : -1;
    var target = (idx >= 0 && customizer.qty > 1 && root.querySelector('[data-unit="' + idx + '"]')) || root.querySelector('section') || root;
    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    target.classList.remove('np-attention');
    void target.offsetWidth;
    target.classList.add('np-attention');
    setTimeout(function () { target.classList.remove('np-attention'); }, 2200);
  }

  /* ---------- Produto ---------- */
  function initProduct() {
    var root = $('[data-product-root]');
    var jsonEl = $('[data-product-json]');
    if (!root || !jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]');
    var variantInput = $('[data-variant-input]');
    var current = product.variants.filter(function (v) { return String(v.id) === String(variantInput.value); })[0] || product.variants[0];

    // Galeria
    var track = $('[data-gallery-track]', root);
    var dots = $$('[data-gallery-dots] > div', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    var setSlide = function (i) {
      dots.forEach(function (d, j) {
        d.classList.toggle('bg-white', i === j); d.classList.toggle('w-4', i === j);
        d.classList.toggle('bg-white/40', i !== j); d.classList.toggle('w-1.5', i !== j);
      });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('border-foreground', i === j);
        t.classList.toggle('border-border', i !== j);
        t.classList.toggle('hover:border-foreground/50', i !== j);
      });
    };
    if (track) {
      track.addEventListener('scroll', function () { setSlide(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = Number(t.getAttribute('data-gallery-thumb'));
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          setSlide(i);
          t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    }
    $$('[data-gallery-video-play]', root).forEach(function (b) {
      b.addEventListener('click', function () { var v = b.parentNode.querySelector('video'); b.remove(); v.controls = true; v.currentTime = 0; v.play(); });
    });

    // Personalizador
    var custEl = $('[data-customizer]', root);
    var customizer = null;
    var startCustomizer = function () {
      if (!custEl) return;
      if (product.type === 'gelacar') { customizer = new GelacarCustomizer(custEl); customizer.plateImage = product.plateImage; }
      else if (product.type === 'capa') customizer = new GelacarCustomizer(custEl, CAPA_MODE);
      else if (product.type === 'gelatruck') { customizer = new GelatruckCustomizer(custEl); customizer.plateImage = product.plateImage; }
      else if (product.type === 'truckbar') customizer = new BarCustomizer(custEl, { productName: 'TruckBar', vehicle: 'caminhão', stations: product.stations });
      else if (product.type === 'autobar') customizer = new BarCustomizer(custEl, { productName: 'AutoBar', vehicle: 'carro', stations: product.stations });
      else if (product.type === 'nome') customizer = new BarCustomizer(custEl, { productName: product.short, nameRequired: true });
      else if (product.type === 'umidcar') customizer = new CarPickCustomizer(custEl, { productName: product.short });
      else if (product.type === 'autocharge') customizer = new AutochargeCustomizer(custEl);
      if (customizer) customizer.setQty(current.units || 1);
    };
    if ((product.type === 'gelacar' || product.type === 'capa') && !window.NP_GELACAR_DATA) window.addEventListener('load', startCustomizer, { once: true });
    else if (product.type === 'gelatruck' && !window.NP_GELATRUCK_DATA) window.addEventListener('load', startCustomizer, { once: true });
    else if (product.type === 'umidcar' && !window.NP_UMIDCAR_DATA) window.addEventListener('load', startCustomizer, { once: true });
    else if (product.type === 'autocharge' && !window.NP_AUTOCHARGE_DATA) window.addEventListener('load', startCustomizer, { once: true });
    else startCustomizer();

    // Variações: cartões de kit + seletores das demais opções (cor, tamanho, marca…)
    var offers = $$('[data-offer]', root);
    var savingsText = $('[data-savings-text]', root);
    var optionGroups = $$('[data-option-group]', root);
    var priceBlock = $('[data-price-block]', root);
    var kitIndex = typeof product.kitIndex === 'number' ? product.kitIndex : -1;
    var selection = (current.options || []).slice();
    var buyBtn = $('[data-buy-now]', root);
    var addBtn = $('[data-add-to-cart]', root);
    function sameOptions(v, opts) { return !!v.options && v.options.every(function (o, i) { return o === opts[i]; }); }
    function findVariant(opts) { return product.variants.filter(function (v) { return sameOptions(v, opts); })[0]; }
    function variantWith(index, value) { var opts = selection.slice(); opts[index] = value; return findVariant(opts); }
    // Combinação inexistente: mantém a opção escolhida e completa com a primeira variante (de preferência disponível) que a tenha.
    function bestVariant(opts, index) {
      var exact = findVariant(opts);
      if (exact) return exact;
      var withValue = product.variants.filter(function (v) { return v.options && v.options[index] === opts[index]; });
      return withValue.filter(function (v) { return v.available; })[0] || withValue[0] || current;
    }
    function styleOffer(o, on) {
      ['border-[hsl(var(--store-blue))]', 'shadow-[0_0_0_1px_hsl(var(--store-blue))]', 'bg-[#f7f9fc]'].forEach(function (c) { o.classList.toggle(c, on); });
      ['border-[#e6e6e6]', 'bg-white'].forEach(function (c) { o.classList.toggle(c, !on); });
      var radio = $('[data-offer-radio]', o);
      if (radio) {
        radio.classList.toggle('border-[hsl(var(--store-blue))]', on);
        radio.classList.toggle('border-[#dcdcdc]', !on);
        radio.firstElementChild.hidden = !on;
      }
    }
    function applyVariant(v, showImage) {
      if (!v) return;
      var unitsChanged = (v.units || 1) !== (current.units || 1);
      current = v;
      selection = (v.options || []).slice();
      variantInput.value = v.id;
      offers.forEach(function (o) {
        var kv = o.getAttribute('data-kit-value');
        var ov = kitIndex >= 0 && kv != null ? variantWith(kitIndex, kv) : null;
        if (!ov) ov = product.variants.filter(function (x) { return String(x.id) === o.getAttribute('data-variant-id'); })[0];
        if (ov) {
          var cmp = ov.compare || ov.price, sav = Math.max(0, cmp - ov.price), pct = cmp > 0 ? Math.round(sav * 100 / cmp) : 0;
          o.setAttribute('data-variant-id', ov.id);
          o.setAttribute('data-savings', formatMoney(sav));
          var pe = $('[data-offer-price]', o), ce = $('[data-offer-compare]', o), me = $('[data-offer-meta]', o);
          if (pe) pe.textContent = formatMoney(ov.price);
          if (ce) ce.textContent = formatMoney(cmp);
          if (me) me.textContent = pct + '% OFF — economize ' + formatMoney(sav);
          o.classList.toggle('np-offer--off', !ov.available);
        }
        styleOffer(o, !!ov && ov.id === v.id);
      });
      if (savingsText) savingsText.textContent = formatMoney(Math.max(0, (v.compare || v.price) - v.price));
      optionGroups.forEach(function (g) {
        var idx = Number(g.getAttribute('data-option-index'));
        var val = selection[idx];
        var cur = $('[data-option-current]', g);
        if (cur) cur.textContent = val;
        $$('[data-option-value]', g).forEach(function (b) {
          var bv = b.getAttribute('data-option-value');
          var alt = variantWith(idx, bv);
          b.setAttribute('aria-pressed', bv === val ? 'true' : 'false');
          b.classList.toggle('np-opt--off', !alt || !alt.available);
        });
        var sel = $('[data-option-select]', g);
        if (sel && sel.value !== val) sel.value = val;
      });
      if (priceBlock) {
        var hasCmp = v.compare > v.price;
        var row = $('[data-compare-row]', priceBlock);
        if (row) row.hidden = !hasCmp;
        if (hasCmp) {
          $('[data-compare]', priceBlock).textContent = formatMoney(v.compare);
          $('[data-pct]', priceBlock).textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
        }
        var pr = $('[data-price]', priceBlock);
        if (pr) pr.textContent = formatMoney(v.price);
        var inst = $('[data-installment]', priceBlock);
        if (inst && v.installment) inst.textContent = v.installment;
      }
      if (buyBtn) { buyBtn.disabled = !v.available; buyBtn.textContent = v.available ? 'Comprar agora' : 'Esgotado'; }
      if (addBtn) addBtn.disabled = !v.available;
      if (showImage && v.media > 0 && track) {
        var mi = v.media - 1;
        track.scrollTo({ left: mi * track.clientWidth, behavior: 'smooth' });
        setSlide(mi);
      }
      try { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(history.state, '', url.toString()); } catch (e) {}
      if (customizer && unitsChanged) customizer.setQty(v.units || 1);
    }
    offers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var kv = btn.getAttribute('data-kit-value');
        if (kitIndex >= 0 && kv != null) {
          var opts = selection.slice(); opts[kitIndex] = kv;
          applyVariant(bestVariant(opts, kitIndex), false);
        } else {
          applyVariant(product.variants.filter(function (x) { return String(x.id) === btn.getAttribute('data-variant-id'); })[0], false);
        }
      });
    });
    optionGroups.forEach(function (g) {
      var idx = Number(g.getAttribute('data-option-index'));
      $$('[data-option-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          var opts = selection.slice(); opts[idx] = b.getAttribute('data-option-value');
          applyVariant(bestVariant(opts, idx), true);
        });
      });
      var sel = $('[data-option-select]', g);
      if (sel) sel.addEventListener('change', function () {
        var opts = selection.slice(); opts[idx] = sel.value;
        applyVariant(bestVariant(opts, idx), true);
      });
    });

    // Comprar
    var busy = false;
    function submit(toCheckout) {
      if (busy) return;
      if (customizer) { var msg = customizer.validate(); if (msg) { toast(msg); showMissing(customizer); return; } }
      var fd = new FormData();
      fd.append('id', variantInput.value);
      fd.append('quantity', '1');
      var units = current.units || 1;
      if (customizer) {
        var res = customizer.properties();
        var props = res.props || res;
        Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
        if (res.files) Object.keys(res.files).forEach(function (k) { fd.append('properties[' + k + ']', res.files[k], 'foto.jpg'); });
      }
      busy = true; buyBtn.disabled = true; addBtn.disabled = true;
      if (toCheckout) showCheckoutLoader();
      addToCart(fd).then(function () {
        if (toCheckout) { goToCheckout(); return; }
        return fetchCart().then(function (cart) { renderCart(cart); showSheet('cart-sheet'); });
      }).catch(function (err) {
        hideCheckoutLoader();
        toast(err.message || 'Não foi possível adicionar ao carrinho.');
      }).then(function () { busy = false; buyBtn.disabled = false; addBtn.disabled = false; });
    }
    if (buyBtn) buyBtn.addEventListener('click', function () { submit(true); });
    if (addBtn) addBtn.addEventListener('click', function () { submit(false); });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });

    // Mídia da descrição: imagens com lazy e vídeos em loop (sem som), como na loja original
    var desc = $('[data-description]', root);
    if (desc) {
      $$('img', desc).forEach(function (img) { if (!/\.gif(\?|$)/i.test(img.src)) img.loading = 'lazy'; img.decoding = 'async'; });
      var videos = $$('video', desc);
      videos.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.loop = true; v.controls = false; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.preload = 'metadata'; });
      var tryPlay = function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window && videos.length) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) tryPlay(en.target); }); }, { rootMargin: '800px 0px' });
        videos.forEach(function (v) { io.observe(v); });
      }
      ['touchstart', 'pointerdown', 'pageshow'].forEach(function (ev) {
        window.addEventListener(ev, function () { videos.forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom >= -400 && r.top <= window.innerHeight + 800 && v.paused) tryPlay(v); }); }, { passive: true });
      });
    }
  }

  /* ---------------- Avaliações ---------------- */
  function initReviews() {
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-review-more]');
      if (more) {
        var p = more.parentNode.querySelector('[data-review-text]');
        if (p) p.textContent = p.getAttribute('data-full');
        more.remove();
        return;
      }
      var all = e.target.closest('[data-reviews-all]');
      if (all) { $$('[data-review-extra]').forEach(function (a) { a.hidden = false; }); all.remove(); }
    });
  }

  function init() {
    initHero();
    initVideoSections();
    initTracking();
    initProduct();
    initReviews();
    initCartBackup();
    var reopen = false;
    try { reopen = !!sessionStorage.getItem(OPEN_CART_FLAG); sessionStorage.removeItem(OPEN_CART_FLAG); } catch (e) {}
    fetchCart().then(function (cart) { renderCart(cart); if (reopen && cart.item_count) showSheet('cart-sheet'); }).catch(function () {});
  }
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init);
})();
